@if (!isDesktop()) {
  <app-header
    [transparent]="false"
    [title]="
      !!plant() ? i18n.parse(plant()?.objectName) : i18n.langString('plant')
    "
    [backRoute]="''"
  >
  </app-header>
}

<div class="content" [class.desktop]="isDesktop()">
  @if (isDesktop()) {
    <div [class.desktop-sidebar]="isDesktop()">
      <app-sidebar [showFilter]="true" [plantsFilter]="true"></app-sidebar>
    </div>
  }

  <div
    [class.desktop-main]="isDesktop()"
    [class.mobile]="isMobile()"
    [class.tablet]="isTablet()"
  >
    @if (plant() && (!emptyResults() || !isDesktop())) {
      <div class="plant-thumbnail-header">
        @if (isDesktop()) {
          <nz-avatar
            [nzSrc]="
              plant()!['thumbnail']
                ? plant()!['thumbnail']
                : 'assets/images/plant_default_picture.png'
            "
            [nzSize]="80"
            nzText="Plant"
          ></nz-avatar>
        }

        <div class="breadcrump-content">
          <app-breadcrumbs
            [object]="plant()"
            class="breadcrumbsSmallMargin"
          ></app-breadcrumbs>
          <h1 class="show_content">{{ plant()!.objectName }}</h1>
        </div>
      </div>

      @if (!isDesktop()) {
        <app-search-filter
          (FilterChanged)="onFilterChanged($event)"
          [filter]="filter()"
        ></app-search-filter>
      }

      @if (!plant()!["filtered"]) {
        @if (!emptyResults()) {
          @for (building of buildings(); track building.objectID) {
            <div class="card-border">
              <app-card
                [plant]="building"
                [isDisabled]="false"
                [detail]="true"
                [showLayer]="true"
                [showsArchived]="true"
              >
                <div class="card-layer">
                  @for (
                    equipment of building.AssociatedEquipments;
                    track equipment.objectID
                  ) {
                    @if (equipment.objectID !== building.objectID) {
                      <div class="card-layer-subtitle">
                        <span class="card-layer-subtitle-layername detail">
                          {{ i18n.parse(equipment.layerName) }}
                        </span>
                        @if (equipment.Assets.length > 0) {
                          <span class="body-bold card-layer-subtitle">
                            {{ i18n.parse(equipment.objectName) }}
                          </span>
                        }
                      </div>
                    }

                    <div class="card-layer-content">
                      @for (asset of equipment.Archived; track asset.objectID) {
                        <app-asset-nav-button
                          [asset]="asset"
                          svg_icon="icons:disconnected"
                        >
                          {{ asset.objectName | nameSlice }}
                        </app-asset-nav-button>
                      }
                    </div>
                  }
                </div>
              </app-card>
            </div>
          }
        }
      } @else {
        <app-card [plant]="plant()" [fine]="false">
          @for (
            bcCluster of assetsGroupBy(plant());
            track bcCluster[0]?.objectID
          ) {
            <app-breadcrumbs [object]="bcCluster[0]"></app-breadcrumbs>
            <div class="search-result-wrapper">
              @for (asset of bcCluster; track asset.objectID) {
                <app-asset-nav-button
                  [asset]="asset"
                  [show_icon]="asset.critical"
                  svg_icon="icons:status-exclamation-triangle"
                >
                  {{ asset.objectName | nameSlice }}
                </app-asset-nav-button>
              }
            </div>
          }
        </app-card>
      }
    }
  </div>
</div>
